import React, { Component } from 'react'
import TextField from 'material-ui/TextField'
import RaisedButton from 'material-ui/RaisedButton'
import axios from 'axios'

class LoginForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user: '',
      password: '',
      error: null
    }
  }

  handleFieldChange = key => {
    return event => {
      this.setState({
        [key]: event.target.value
      })
    }
  }
  loginCall = async () => {
    this.props.toggleLoadingState()
    const { user, password } = this.state
    let response = await axios.post(`/api/login`, {
      user: user.trim(),
      password: password.trim()
    })
    const { error, serials, token } = response.data
    if (error) {
      this.setState({ error })
    }
    if (!error && token) {
      const freshData = {
        user,
        serials,
        token,
        open: false
      }
      localStorage.setItem('sws', JSON.stringify(freshData))
      this.props.setBodyState(freshData)
    }
    this.props.toggleLoadingState()
  }

  handleSubmit = event => {
    event.preventDefault()
    this.loginCall()
  }

  render() {
    const { user, password } = this.state
    return (
      <div
        style={{
          width: '90%',
          margin: '0px auto'
        }}
      >
        <form onSubmit={this.handleSubmit}>
          <TextField
            floatingLabelText="User"
            value={user}
            onChange={this.handleFieldChange('user')}
          />
          <br />
          <TextField
            floatingLabelText="Password"
            type="password"
            errorText={this.state.error}
            value={password}
            onChange={this.handleFieldChange('password')}
          />
          <br />
          <RaisedButton
            disabled={this.props.loading}
            label="Login"
            primary={false}
            onClick={this.loginCall}
          >
            <input
              type="submit"
              style={{ display: 'none' }}
            />
          </RaisedButton>
        </form>
      </div>
    )
  }
}

export default LoginForm



// WEBPACK FOOTER //
// ./src/components/LoginForm.js